let callingCart = false;
function rtBuyNow(variant_id, qty, selling_plan) {
  console.log(variant_id, qty, selling_plan);
  if (callingCart) {
    return;
  }
  if (passValidation()) {
    callingCart = true;
    fetch('/cart/clear.js', { method: 'POST' })
      .then(() => {
        fetch('/cart/add.js', 
          { 
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              "id": variant_id,
              "quantity": qty,
              "selling_plan": selling_plan,
              "properties": {
                'Passholder First Name': document.getElementById('passholder-fname').value,
                'Passholder Last Name': document.getElementById('passholder-lname').value,
                'Passholder Email': document.getElementById('passholder-email').value,
              },
            })
          })
          .then(() => {
            window.location.href = '/checkout';
          })
          .catch(err => {
            console.error('Add to cart failed:', err)
            callingCart = false;
          })
      })
      .catch(err => {
        console.error('Clear cart failed:', err);
        callingCart = false;
      })
  }
}

function passValidation() {
  var passHolderNameF = document.getElementById("passholder-fname").value;
  var passHolderNameL = document.getElementById("passholder-lname").value;
  var passHolderEmail = document.getElementById("passholder-email").value;

  if ( passHolderNameF == ''){
    document.getElementById('passholder-fname').classList.add('required_filed');
  } else if ( passHolderNameL == ''){
    document.getElementById('passholder-lname').classList.add('required_filed');
  } else if ( passHolderEmail == '' || !validateEmail(passHolderEmail)){
     document.getElementById('passholder-email').classList.add('required_filed');
  }
  else {
    document.getElementById('passholder-fname').classList.remove('required_filed');
    document.getElementById('passholder-lname').classList.remove('required_filed');
    document.getElementById('passholder-email').classList.remove('required_filed');
    return true;
  }
  return false;
}

function validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
}

function keyPressPassHolderNameF(){
  var passHolderName2 = document.getElementById("passholder-fname").value;
  if ( passHolderName2 == ''){
    document.getElementById('passholder-fname').classList.add('required_filed');
  }
  else {
    document.getElementById('passholder-fname').classList.remove('required_filed');
  }
} 
function keyPressPassHolderNameL(){
  var passHolderName2 = document.getElementById("passholder-lname").value;
  if ( passHolderName2 == ''){
    document.getElementById('passholder-lname').classList.add('required_filed');
  }
  else {
    document.getElementById('passholder-lname').classList.remove('required_filed');
  }
} 
function keyPressPassHolderEmail(){
  var passHolderEmail2 = document.getElementById("passholder-email").value;
  if ( passHolderEmail2 == '' || !validateEmail(passHolderEmail2)){
     document.getElementById('passholder-email').classList.add('required_filed');
  }
  else {
    document.getElementById('passholder-email').classList.remove('required_filed');
  }
}

function hideShowPayBtns() {
  const wrapper = document.querySelector('.payment-btn-wrapper');
  if (!wrapper) {
    return;
  }
  if (passValidation()) {
    wrapper.style.opacity = 1;
    wrapper.style.pointerEvents = null;
  } else {
    wrapper.style.opacity = 0.25;
    wrapper.style.pointerEvents = 'none';
  }
}

const form = document.querySelector('form.product-form');
if (form) {
  hideShowPayBtns();
  form.addEventListener('input', () => {
    console.log('yay');
    hideShowPayBtns();
  });
}